import User from 'components/Item/User.js'
import { ListRowItem } from 'components/ListRowItem'
import { View } from 'components/View'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import { getInstanceUserSectionSelector } from 'modules/section/selectors'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import Link from 'components/Link'
import { createSelector } from 'reselect'
import { toHumanReadableStringDatetimeUtil } from 'utils/datetime'

class LogItem extends React.Component {
  static defaultProps = {
    hasLink: null
  }

  static propTypes = {
    instance: PropTypes.object,
    user: PropTypes.object,
    isCompact: PropTypes.bool.isRequired,
    hasLink: PropTypes.bool
  }

  handleClick () {
  }

  renderUser () {
    const { user } = this.props
    if (!user) {
      return
    }
    return <User value={user} />
  }

  renderBody () {
    if (!this.props.hasLink ||
      !this.props.user) {
      return this.renderItem()
    }
    const id = this.props.instance.data.id
    const link = interpolateRouteUtil(
      ROUTE_PATH.LOGS_BY_USERNAME_OR_ID,
      { userNameOrId: id }
    )
    return (
      <Link
        onClick={this.handleClick.bind(this)}
        to={link}
      >
        {this.renderItem()}
      </Link>
    )
  }

  renderItem () {
    return (
      <View
        style={{
          flexDirection: this.props.isCompact
            ? View.DIRECTION.COLUMN
            : View.DIRECTION.ROW
        }}
      >
        <div style={{ flexGrow: '1' }}>
          <span>{this.props.instance.data.text}</span>
        </div>
        <div>
          <span>
            {toHumanReadableStringDatetimeUtil(new Date(this.props.instance.data.createdAt))}
          </span>
        </div>
      </View>
    )
  }

  render () {
    return (
      <ListRowItem>
        {this.renderUser()}
        {this.renderBody()}
      </ListRowItem>
    )
  }
}

const select = () => createSelector(
  getInstanceUserSectionSelector(),
  (user) => (
    {
      user
    }
  )
)
export default connect(select)(
  LogItem)
